import './LoadingStyle.scss';

import { LoadingIndicator } from '@tfecom-thermofisher/react-komodo-design';
import PropTypes from 'prop-types';
import React from 'react';

const Loading = ({ isLoading }) => (
  <div className="loading-overlay">
    <LoadingIndicator
      isLoading={isLoading}
      data-testid="qa-loading-indicator"
    />
  </div>
);

Loading.propTypes = {
  isLoading: PropTypes.bool,
};

export default Loading;
